module.exports = __webpack_public_path__ + "media/images/pic/warsaw-card-94afd06a15a411af5c2cbccec4a750ba.jpg";